export const getStrikePrecision = (price: number): number => {
  if (price >= 100) {
    return 0; // No decimal places for prices 100 and above
  }

  if (price >= 10) {
    return 1; // One decimal place for prices between 10 and 99.99
  }

  return 2; // Two decimal places for prices below 10
};
